import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { fetchSiteInfo } from "../actioncreators/site";

const initialState = {
  siteInfo: [],
  isLoading: false,
  registerLoading: false,
  filesUploading: false,
  sidebar: {
    open: true,
    minimize: false,
  },
  newRequest: {
    open: false,
    type: null as string | null,
    editMode: false,
    editId: undefined as number | undefined,
    showInterPaymentAlert: false,
  },
  alertModal: {
    open: false,
    type: "success",
    message: "",
    okFunc: null,
    body: "",
  },
};

export const siteSlice = createSlice({
  name: "site",
  initialState,
  reducers: {
    setIsLoading(
      state: { isLoading: boolean },
      action: PayloadAction<boolean>,
    ) {
      state.isLoading = action.payload;
    },
    setRegisterLoading(
      state: { registerLoading: boolean },
      action: PayloadAction<boolean>,
    ) {
      state.registerLoading = action.payload;
    },
    setFilesUploading(state, action: PayloadAction<boolean>) {
      state.filesUploading = action.payload;
    },
    setAlertModal(state, action: PayloadAction<any>) {
      state.alertModal = action.payload;
    },
    setShowAlertModal(state, action: PayloadAction<boolean>) {
      state.alertModal.open = action.payload;
    },
    // sidebar
    setShowSidebar(state, action: PayloadAction<boolean>) {
      state.sidebar.open = action.payload;
    },
    setSidebarMin(state, action: PayloadAction<boolean>) {
      state.sidebar.minimize = action.payload;
    },
    // new request
    setShowNewRequest(state, action: PayloadAction<boolean>) {
      state.newRequest.open = action.payload;
    },
    setNewRequestType(state, action: PayloadAction<string | null>) {
      state.newRequest.type = action.payload;
    },
    setEditMode(state, action: PayloadAction<boolean>) {
      state.newRequest.editMode = action.payload;
    },
    setEditId(state, action: PayloadAction<number | undefined>) {
      state.newRequest.editId = action.payload;
    },
    setShowInterPaymentAlert(state, action: PayloadAction<boolean>) {
      state.newRequest.showInterPaymentAlert = action.payload;
    },
  },
  extraReducers: {
    [fetchSiteInfo.pending.type]: (state) => {},
    [fetchSiteInfo.fulfilled.type]: (state, action) => {
      state.siteInfo = action.payload;
    },
    [fetchSiteInfo.rejected.type]: (state, action) => {},
  },
});

export default siteSlice.reducer;

export const {
  setIsLoading,
  setRegisterLoading,
  setFilesUploading,
  setAlertModal,
  setShowAlertModal,
  setShowSidebar,
  setSidebarMin,
  setShowNewRequest,
  setNewRequestType,
  setEditMode,
  setEditId,
  setShowInterPaymentAlert,
} = siteSlice.actions;
